import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { CompareFacade } from 'src/app/extensions/compare/facades/compare.facade';
import { OrderTemplatesFacade } from 'src/app/extensions/order-templates/facades/order-templates.facade';
import { OrderTemplate } from 'src/app/extensions/order-templates/models/order-template/order-template.model';
import { WishlistsFacade } from 'src/app/extensions/wishlists/facades/wishlists.facade';
import { Wishlist } from 'src/app/extensions/wishlists/models/wishlist/wishlist.model';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { FilterNavigation } from 'ish-core/models/filter-navigation/filter-navigation.model';
import { HttpError } from 'ish-core/models/http-error/http-error.model';
import { FeatureToggleService } from 'ish-core/utils/feature-toggle/feature-toggle.service';
import { URLFormParams } from 'ish-core/utils/url-form-params';

@Component({
  selector: 'ish-filter-navigation-sidebar',
  templateUrl: './filter-navigation-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterNavigationSidebarComponent {
  @Input({ required: true }) filterNavigation: FilterNavigation;
  @Output() applyFilter = new EventEmitter<{ searchParameter: URLFormParams }>();

  /**
   * The list of wishlists of the customer.
   */
  wishlists$: Observable<Wishlist[]>;
  /**
   * The list of order templates of the customer.
   */
  orderTemplates$: Observable<OrderTemplate[]>;
  /**
   * Indicator for loading state of order templates
   */
  orderTemplateLoading$: Observable<boolean>;
  /**
   * Error state in case of an error during creation of a new order template.
   */
  orderTemplateError$: Observable<HttpError>;
  isWishlist$: Observable<boolean>;
  isOrderTemplate$: Observable<boolean>;
  wishlistLoading$: Observable<boolean>;
  wishlistError$: Observable<HttpError>;

  compareProducts$: Observable<string[]>;
  isLoggedIn$: Observable<boolean>;
  constructor(
    private orderTemplatesFacade: OrderTemplatesFacade,
    private compareFacade: CompareFacade,
    private accountFacade: AccountFacade,
    private wishList: WishlistsFacade,
    private featureToggleService: FeatureToggleService,
    private wishlistsFacade: WishlistsFacade
  ) {}

  ngOnInit() {
    this.orderTemplates$ = this.orderTemplatesFacade.currentUsersOrderTemplates$();
    this.orderTemplateLoading$ = this.orderTemplatesFacade.orderTemplateLoading$;
    this.wishlists$ = this.wishList.wishlists$;
    this.orderTemplateError$ = this.orderTemplatesFacade.orderTemplateError$;
    this.compareProducts$ = this.compareFacade.compareProducts$;
    this.isLoggedIn$ = this.accountFacade.isLoggedIn$;
    this.isWishlist$ = this.featureToggleService.enabled$('wishlists');
    this.isOrderTemplate$ = this.featureToggleService.enabled$('orderTemplates');
    this.wishlistLoading$ = this.wishlistsFacade.wishlistLoading$;
    this.wishlistError$ = this.wishlistsFacade.wishlistError$;
  }
  /**
   * keeps the collapsed state of sub components when changing filters
   */
  collapsedElements: { [id: string]: boolean } = {};

  /**
   * keeps the show all state of sub components when changing filters
   */
  showAllElements: { [id: string]: boolean } = {};
}
